import { Typography } from '@material-ui/core';
import {
  categorizeOrderInsightRisks,
  getParentSeverity,
  PropertyOrderInsightsProps,
  RiskCategory,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import orderInsightStyles from './OrderInsightStyles';

const EstMarketValue: React.FC<PropertyOrderInsightsProps> = ({ property, isPdf }) => {
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    property.risks,
    RiskCategory.MarketValue,
  );

  const classes = orderInsightStyles();

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.displayFlex, classes.flexGrow)}>
        <div className={classes.labelCol}>
          <span className={clsx(classes.displayFlex, classes.alignCenter)}>
            <OrderInsightsRiskIcon
              isPdf={isPdf}
              riskSeverity={getParentSeverity(property.risks, RiskCategory.MarketValue)}
            />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              Est. Market Value:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          {(property.taxInformation?.marketValue ?? -1) >= 0 && (
            <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
              {Number(property.taxInformation?.marketValue).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}
            </Typography>
          )}
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
            className={(property.taxInformation?.marketValue ?? -1) < 0 ? classes.removeFirstAlertMargin : ''}
          />
        </div>
      </div>
    </div>
  );
};

export default EstMarketValue;
